import { useMemo } from "react";
import { useTable } from "react-table";
// import { formatCurrency } from "../../../../helpers";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { formatCurrency } from "../../../../helpers";
import { useSelector } from "react-redux";

export const useBillsItemsTable = ({
  billsItems = [],
  billsDetails = null,
}) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const storeMap = useMemo(() => {
    return (storeList || []).reduce((acc, store) => {
      acc[store.id] = store;
      return acc;
    }, {});
  }, [storeList]);

  const columns = useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "product_name",
      },
      {
        Header: "Store",
        accessor: "store_id",
        Cell: ({ cell: { value } }) => storeMap[value]?.name || "N/A",
      },
      {
        Header: "Ordered Qty",
        accessor: "requested_quantity",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock"]}
            style={{ minWidth: "auto" }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "QTY received (Till date)",
        accessor: "total_received",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock"]}
            style={{ minWidth: "auto" }}
          >
            {value}
          </span>
        ),
      },

      {
        Header: "Billed Qty (Till Date)",
        accessor: "total_billed",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock"]}
            style={{ minWidth: "auto" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "Bill QTY",
        accessor: "bill_quantity",
        Cell: ({ cell: { value } }) => (
          <span
            className={`${globalStyles.statusBlock}`}
            style={{ minWidth: "auto" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "Remaining to Bill",
        Cell: ({ row }) => {
          const quantity_short = Number(row?.original?.remaining_billable || 0);

          return (
            <span
              className={`${quantity_short <= 0 ? globalStyles["statusBlock--success"] : globalStyles["statusBlock--failed"]}`}
              style={{ minWidth: "auto" }}
            >
              {quantity_short}
            </span>
          );
        },
      },
      {
        Header: "Cost Price",
        accessor: "cost_price",
        Cell: ({ cell: { value }, row }) =>
          formatCurrency({
            value: Number(value),
            currencyCode: storeMap?.[row?.original?.store_id]?.currency_code,
          }),
      },
      {
        Header: "Line Total",
        Cell: ({ row }) =>
          formatCurrency({
            value:
              Number(row?.original?.cost_price) *
              Number(row?.original?.bill_quantity || 0),
            currencyCode: storeMap?.[row?.original?.store_id]?.currency_code,
          }),
      },
    ],
    [],
  );

  const instance = useTable({
    columns,
    data: billsItems || [],
  });

  return {
    instance,
  };
};
